import styled from "@emotion/styled";
import { Label } from "react-aria-components";

export const StyledLabel = styled(Label)(props => ({
  fontSize: props.theme.fontSizes.smedium,
  color: props.theme.colors.grey.x600,
}));
